module.exports = __webpack_public_path__ + "5614d388d36f6cab27fa6de4fdbac6de.svg";